import { composeDataModules } from '@perpay-web/data-module/composeDataModules';
import { fetchCardAccountsDataModule } from '@perpay-web/fintech/dataModules/fetchCardAccounts';
import { fetchJobsDataModule } from '@perpay-web/fintech/dataModules/fetchJobs';
import { generalAccountSummaryDataModule } from '@perpay-web/fintech/dataModules/generalAccountSummary';
import { setStepsForUpdateDirectDepositDataModule } from '@perpay-web/fintech/dataModules/setStepsForUpdateDirectDeposit';

const dataModules = [
    fetchCardAccountsDataModule,
    generalAccountSummaryDataModule,
    setStepsForUpdateDirectDepositDataModule,
    fetchJobsDataModule,
];

const UpdateDirectDepositDataModule = composeDataModules(dataModules);

const getRoot = (state) => state.dataModules.updateDirectDeposit;

export const updateDirectDepositDataModule = UpdateDirectDepositDataModule({
    getRoot,
    key: 'UPDATE_DIRECT_DEPOSIT',
});
